import types from 'redux/types';
import { checkTypeValue } from 'helpers';
import {
  baseGetGuideLine,
  baseGetGuideLineByRole,
  baseSaveGuideline,
  fetchGuideline,
  fetchGuidelineByRole,
  fetchGuidelineByRoleFailed,
  fetchGuidelineByRoleSuccess,
  fetchGuidelineFailed,
  fetchGuidelineSuccess,
  saveGuideline,
  saveGuidelineFailed,
  saveGuidelineSuccess,
} from 'redux/handleReducers/guideline';

const initialState = {
  ...baseGetGuideLine(),
  ...baseGetGuideLineByRole(),
  ...baseSaveGuideline(),
};

export default (state, actions) => {
  if (checkTypeValue(state, 'undefined')) {
    return initialState;
  }

  switch (actions.type) {
    case types.REQUEST_GET_GUIDE:
      return fetchGuideline(actions, state);

    case types.REQUEST_GET_GUIDE_SUCCESS:
      return fetchGuidelineSuccess(actions, state);

    case types.REQUEST_GET_GUIDE_FAILED:
      return fetchGuidelineFailed(actions, state);

    case types.REQUEST_GET_GUIDE_BY_ROLE:
      return fetchGuidelineByRole(actions, state);

    case types.REQUEST_GET_GUIDE_BY_ROLE_SUCCESS:
      return fetchGuidelineByRoleSuccess(actions, state);

    case types.REQUEST_GET_GUIDE_BY_ROLE_FAILED:
      return fetchGuidelineByRoleFailed(actions, state);

    case types.REQUEST_SAVE_GUIDE:
      return saveGuideline(actions, state);

    case types.REQUEST_SAVE_GUIDE_SUCCESS:
      return saveGuidelineSuccess(actions, state);

    case types.REQUEST_SAVE_GUIDE_FAILED:
      return saveGuidelineFailed(actions, state);

    default:
      return state;
  }
};
